import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, SubmissionError } from 'redux-form';
import { bindActionCreators } from 'redux';
import * as registrationActions from '../actions/registrationActions';
import HeaderForm from '../components/Header';
import signOutUrl from '../lib/signOutUrl';
import * as amplitude from '../lib/amplitude';
import * as userActions from '../actions/userActions';

export function logoutDescription(user) {
  let description = '';

  if (user) {
    description = user.firstName
      ? `${user.firstName} ${user.lastName}`
      : user.username;
  }
  return description;
}

export class HeaderFormContainer extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleItemLogout = this.handleItemLogout.bind(this);
    this.handleTrackEvent = this.handleTrackEvent.bind(this);
  }

  componentDidMount() {
    const {
      actions,
      applicationId,
      authToken,
      registration,
    } = this.props;
    if (!registration) actions.fetchRegistration(applicationId, authToken);
  }

  handleTrackEvent() {
    const fdcnId = this.props.registration ? this.props.registration.fdcnId : null;
    const isTseu = this.props.application && this.props.application.isTSEU;
    const eventProperties = {
      exit_method: 'logout',
      promo_code: this.props.registration ? this.props.registration.promoCode : null,
      application_id: this.props.applicationId,
      tradestation_entity: isTseu ? 'tseu' : 'tss',
    };
    amplitude.trackEvent('aop_exit', eventProperties, fdcnId);
  }

  handleItemLogout() {
    this.handleTrackEvent();
    this.props.actions.userLogout(this.props.authToken)
      .then(() => {
        setTimeout(() => {
          window.location = signOutUrl('/logout.html?manual');
        }, 500); // 0.5 second delay so that handleTrackEvent runs
      })
      .catch((error) => { throw new SubmissionError({ _error: error.message }); });
  }

  render() {
    return (
      <HeaderForm
        showUserMenu={this.props.showUserMenu}
        userDescription={this.props.userDescription}
        onItemLogout={this.handleItemLogout}
        location={this.props.location}
      />
    );
  }
}

HeaderFormContainer.propTypes = {
  authToken: PropTypes.string,
  showUserMenu: PropTypes.bool,
  userDescription: PropTypes.string,
  actions: PropTypes.shape({
    userLogout: PropTypes.func.isRequired,
    fetchRegistration: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.string,
  applicationId: PropTypes.string,
  registration: PropTypes.shape(),
  application: PropTypes.shape(),
};

function mapStateToProps(state) {
  return {
    authToken: state.authToken,
    userId: state.userId,
    showUserMenu: state.authToken !== null,
    userDescription: logoutDescription(state.user),
    user: state.user,
    registration: state.registration,
    applicationId: state.applicationId,
    application: state.application,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({},
      userActions, registrationActions),
    dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  enableReinitialize: true,
  form: 'header',
})(HeaderFormContainer));
